import NewIcon from '@/assets/icons/new-device-icon.svg';
import ProductionDoneIcon from '@/assets/icons/production-done-device-icon.svg';
import ReadyForDeploymentIcon from '@/assets/icons/ready-for-deployment-device-icon.svg';

export const deploymentStatuses = translate => [
    { id: 'new', name: translate('selectOptions.deploymentStatusLongChoices.new'), icon: NewIcon },
    { id: 'productionDone', name: translate('selectOptions.deploymentStatusLongChoices.productionDone'), icon: ProductionDoneIcon },
    { id: 'readyForDeployment', name: translate('selectOptions.deploymentStatusLongChoices.readyForDeployment'), icon: ReadyForDeploymentIcon },
];

export const deploymentStatusesFilters = translate =>
    deploymentStatuses(translate).map(({ id, name }) => ({
        id,
        name,
    }));
